import DetailsBlock from './DetailsBlock';
import { DetailsBlockProps, DetailsBlockValueProps } from './types';

export type { DetailsBlockProps, DetailsBlockValueProps };
export default DetailsBlock;
